import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, ConfirmationModal, Typography } from 'seagull';
import { OpenTab } from 'seagull/icons';
import { CopyToClipboard } from '~/components/CopyToClipboard/CopyToClipboard';
import { openInNewTabProps } from '~/constants';
import { useOnMount } from '~/hooks/useOnMount';
import { useLocaleKeys } from '~/i18n';
import styles from './ZapierLegacyModal.module.scss';
export default function ZapierLegacyModal(param) {
    let { dismissModal, getApiKey, onCopyApiKey } = param;
    const { t: texts } = useLocaleKeys('integrations.availableApps.zapier');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { t: commonTexts } = useLocaleKeys('common');
    const [apiKey, setApiKey] = useState('');
    const [helperText, setHelperText] = useState('');
    useOnMount(()=>{
        getApiKey().then(setApiKey).catch(()=>setHelperText(sharedTexts.apiKeyNotFound()));
    });
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'zapier_card_confirm'
            },
            secondaryButton: {
                name: 'zapier_card_cancel'
            }
        },
        title: texts.title(),
        width: "760px",
        content: /*#__PURE__*/ _jsxs("div", {
            className: styles.modalContainer,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.integrateSteps()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.step1()
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.copyApiKeyContainer,
                    children: /*#__PURE__*/ _jsx(CopyToClipboard, {
                        testId: "zapier-api-key",
                        value: apiKey,
                        helperText: helperText,
                        error: !!helperText,
                        onClick: onCopyApiKey
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.stepsContainer,
                    children: /*#__PURE__*/ _jsx(Typography, {
                        children: texts.step2()
                    })
                }),
                /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                    bi: {
                        name: 'go_to_zapier'
                    },
                    skin: "primaryOutline",
                    testId: "go-to-zapier",
                    as: "a",
                    suffixIcon: /*#__PURE__*/ _jsx(OpenTab, {}),
                    href: "https://zapier.com/app/connections"
                }, openInNewTabProps), {
                    className: styles.goToContainer,
                    children: texts.goToZapier()
                }))
            ]
        }),
        primaryButtonLabel: commonTexts.buttons.close(),
        onPrimaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal,
        testId: "integrate-with-zapier-modal"
    });
}
